var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-image-container"},[(_vm.thumbnailUrl)?_c('img',{attrs:{"src":_vm.thumbnailUrl,"alt":"Produktbild"}}):_c('div',{staticClass:"image-placeholder"},[_vm._v(_vm._s(_vm.$t('message.missing.image')))])])}
var staticRenderFns = []

export { render, staticRenderFns }